var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof RTK !== "undefined") return resolve();
	__webpack_require__.l("https://cdn.jsdelivr.net/npm/@reduxjs/toolkit@1.7.2/dist/redux-toolkit.umd.min.js", (event) => {
		if(typeof RTK !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "RTK");
}).then(() => (RTK));